.articles {
    display: block;
}

.backToPress {
    display: flex;
    justify-content: center;

    a {
        align-items: center;
        color: var(--color-lobster);
        display: flex;
        font-size: 1.125rem;
        font-weight: 700;
        justify-content: center;
        text-transform: uppercase;
        text-decoration: none;

        svg {
            width: 0.8em;
            height: 0.8em;
            fill: var(--color-lobster);
        }
    }
}
